// extracted by mini-css-extract-plugin
export const mainContainer = "legalStyles-module--mainContainer--x5sFp";